<script>
    import {fade} from 'svelte/transition';
    import user from "../../stores/user";
    import R from "../../lib/requests";
    import {setFocusTo} from "../../lib/lib";
    import Alert from "../../stores/alerts";
    import AppIcon from "../icons/AppIcon.svelte";

    let username = '';
    let password = '';
    let error = false;
    let viewPassword = false;

    const login = () => {

        const onSuccess = result => {
            user.setUser(result);
        }

        const onFailure = err => {
            error = true;
            if (err.code === 'user_not_active') {
                Alert.warning("Λογαριασμός", "Ο λογαριασμός σας δεν είναι ενεργός!\nΕπικοινωνήστε με τον διαχειριστή για περισσότερες λεπτομέρειες.");
            } else {
                setFocusTo('login-email');
            }
        };

        error = false;
        R.handle(R.app.login, {username, password}, onSuccess, onFailure);
    }

    setFocusTo('login-email');
</script>

<div class="login-overlay" transition:fade="{{ duration: 100 }}">
    <div class="login-content">
        <div class="login-inner" class:error={ error }>
            <div class="login-logo">
                <img src="/assets/images/login-logo.png" alt="logo">
            </div>
            <form on:submit|preventDefault|stopPropagation="{ login }">
                <div class="form-group">
                    <input type="email" class="form-control" id="login-email" bind:value="{ username }" placeholder="email" required>
                </div>
                <div class="form-group">
                    <div class="input-group">
                        {#if viewPassword}
                            <input type="text" class="form-control" bind:value="{ password }" placeholder="password"
                                   required>
                        {:else}
                            <input type="password" class="form-control" bind:value="{ password }" placeholder="password"
                                   required>
                        {/if}
                        <div class="btn btn-default" type="button" on:click="{ () => viewPassword = !viewPassword }">
                            <AppIcon icon="eye" size="18" strokeWidth="2"/>
                        </div>
                    </div>
                </div>
                <button class="btn btn-primary btn-block">SIGN IN</button>
            </form>
        </div>
    </div>
</div>

<style>
    .login-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: #f2f6f8;
        z-index: 9000;
    }

    .login-content {
        position: absolute;
        width: 80%;
        max-width: 300px;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
    }

    .login-inner {
        position: relative;
        max-width: 250px;
    }

    .login-logo {
        margin-bottom: 20px;
    }

    .login-logo img {
        width: 100%;
    }

    .login-inner.error {
        animation: shake 0.82s cubic-bezier(.36, .07, .19, .97) both;
        transform: translate3d(0, 0, 0);
        backface-visibility: hidden;
        perspective: 1000px;
    }
</style>